import { usePracticeProductPricing } from '../../../../hooks/useBilling';
import { PracticePricingSection } from '../../../billing/practice-insights/PracticePricingSection';

interface PracticePricingTabProps {
    practiceId: string;
    practiceName: string;
}

// The exact billing Pricing tab body (resolved product catalog + eligibility
// editor), scoped to this practice and mounted inside the Accounts practice
// detail page.
export function PracticePricingTab({ practiceId, practiceName }: PracticePricingTabProps) {
    const { pricedProducts, isLoading } = usePracticeProductPricing(practiceId);

    return (
        <PracticePricingSection
            practiceId={practiceId}
            practiceName={practiceName}
            pricedProducts={pricedProducts}
            isLoading={isLoading}
        />
    );
}
